// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import '../styles/files.css';
import '../styles/sortable.css';
import Scrollbars from 'react-custom-scrollbars';
import Loading from 'react-loading';

export default class Sortable extends React.Component {

    state = {
        sortBy: "",
        sortDir: -1,
        data: []
    }

    componentDidMount = () => {
        this.sortAndReload(
            this.props.defaultSortBy ?? "name",
            this.props.defaultSortDir !== undefined ? this.props.defaultSortDir : 1
        );
    }

    componentDidUpdate = (prev) => {
        // If we want to preserve locations until re-sorted (in case we're editing in place), then pass the prop: "preserveLocationsByKey: _id" with the unique identifier that will never be changed.
        if (this.props.preserveLocationsByKey) {
            if (JSON.stringify(prev.data?.map(d => d[this.props.preserveLocationsByKey])) !== JSON.stringify(this.props.data?.map(d => d[this.props.preserveLocationsByKey]))) {
                this.setState({ data: this.sort() });
            }
            return;
        }

        // Check deep if data has changed (not just reference)
        if (JSON.stringify(prev.data) !== JSON.stringify(this.props.data))
            this.setState({ data: this.sort() });
    }

    sortAndReload = (sortBy, sortDir) => {
        this.setState({ sortBy, sortDir }, () => this.setState({ data: this.sort() }));
    }

    sort = () => {
        let { sortBy, sortDir } = this.state;

        if (sortBy === "")
            return this.props.data;

        let sorted = this.props.data.slice();
        sorted.sort((a,b) => a[sortBy] > b[sortBy] ? sortDir : a[sortBy] < b[sortBy] ? -sortDir : 0);
        return sorted;
    }

    toggleHeader = (key) => async () => {
        if (this.props.disableSort) return;
        const sortBy = key;
        const sortDir = this.state.sortBy === key ? (this.state.sortDir > 0 ? -1 : 1) : 1;
        this.sortAndReload(sortBy, sortDir);
    }

    getSortArrow = (key) => {
        if (this.state.sortBy !== key)
            return "";

        return this.state.sortDir > 0 ? <>▴&nbsp;</> : <>▾&nbsp;</>;
    }

    renderLeft = (value, width, classes="") => (<div
        className={"stack-list-meta-col document-list-meta-col " + classes}
        style={{ width }}
    >{value}</div>)

    renderMeta = (value, width, classes="") => (<div
        className={"stack-list-meta-col document-list-meta-col " + classes}
        style={{ width }}
    >{value}</div>)

    render = () => {
        const data = this.state.data;
        return (<>
            {this.props.scrollbar ? 
                <Scrollbars
                renderTrackVertical={props => <div className="scrollbar-track-v" {...props} />}
                renderTrackHorizontal={props => <div className="scrollbar-track-h" {...props} />}
                renderThumbVertical={props => <div className="scrollbar-thumb-v" {...props} />}
                renderThumbHorizontal={props => <div className="scrollbar-thumb-h" {...props} />}
                style={{height: 500}}
            >
            <div className={"sortable-list " + (this.props.className ?? "")}>
                {this.props.title ? <h1>{this.props.title}</h1> : ""}

                <div
                    className='stack-list-header'
                    style={this.props.header.style?? {
                        minWidth: this.props.header.minWidth ? this.props.header.minWidth : 660,
                        borderBottom: this.props.header.borderBottom ? this.props.header.borderBottom : '1px solid var(--color-border)',
                        height: this.props.header.height + 1 ? this.props.header.height : 32
                    }}
                >
                    <div
                        className="stack-list-header-left stack-list-header-link"
                        title="Click to sort by key"
                        onClick={this.toggleHeader(this.props.header.name.prop)}
                        style={{
                            paddingLeft: '20px',
                            ...(this.props.header.name.width ? { width: this.props.header.name.width } : {})
                        }}
                    >{this.getSortArrow(this.props.header.name.prop)}{this.props.header.name.label}</div>
                    
                    {this.props.header.left ? <div className="stack-list-left">
                        {this.props.header.left.map((l,idx) => <div
                            key={idx}
                            className={"stack-list-header-item stack-list-header-link " + (l.classes ? l.classes : "")}
                            title="Click to sort by key"
                            onClick={this.toggleHeader(l.prop)}
                            style={{ width: l.width }}
                            >{this.getSortArrow(l.prop)}{l.label}</div>)}
                    </div> : ""}

                    <div className="stack-list-meta">
                        {this.props.header.meta.map((m,idx) => <div
                            key={idx}
                            className={"stack-list-header-item stack-list-header-link " + (m.classes ? m.classes : "")}
                            title="Click to sort by key"
                            onClick={this.toggleHeader(m.prop)}
                            style={{ width: m.width }}
                        >{this.getSortArrow(m.prop)}{m.label}</div>)}
                    </div>
                </div>
                    {/* Render items through custom configuration */}
                    {data.length > 0 ? data.map((item,idx) => this.props.renderItem(item, idx, this.renderMeta, this.renderLeft)) : <div className="sortable-list-empty">{this.props.emptyMessage ? this.props.emptyMessage : "You don't have any items."}</div>}
                </div>
            </Scrollbars>:
            <div className={"sortable-list " + (this.props.className ?? "")}>
                {this.props.title ? <h1>{this.props.title}</h1> : ""}

                <div
                    className='stack-list-header'
                    style={this.props.header.style?? {
                        minWidth: this.props.header.minWidth ? this.props.header.minWidth : 660,
                        borderBottom: this.props.header.borderBottom ? this.props.header.borderBottom : '1px solid var(--color-border)',
                        height: this.props.header.height + 1 ? this.props.header.height : 32
                    }}
                    // style={{ minWidth: this.props.header.minWidth ? this.props.header.minWidth : 660 }}
                >
                    <div
                        className="stack-list-header-left stack-list-header-link"
                        title="Click to sort by key"
                        onClick={this.toggleHeader(this.props.header.name.prop)}
                        style={{
                            
                            ...(this.props.header.name.paddingLeft ? { paddingLeft: this.props.header.name.paddingLeft } : {paddingLeft: '20px'}),
                            ...(this.props.header.name.width ? { width: this.props.header.name.width } : {}),
                            ...(this.props.header.name.marginLeft ? { marginLeft: this.props.header.name.marginLeft } : {}),
                            ...(this.props.header.name.textAlign ? { textAlign: this.props.header.name.textAlign } : {}),

                        }}
                    >{this.getSortArrow(this.props.header.name.prop)}{this.props.header.name.label}</div>
                    
                    {this.props.header.left ? <div className="stack-list-left">
                        {this.props.header.left.map((l,idx) => <div
                            key={idx}
                            className={"stack-list-header-item stack-list-header-link " + (l.classes ? l.classes : "")}
                            title="Click to sort by key"
                            onClick={this.toggleHeader(l.prop)}
                            style={{ width: l.width }}
                            >{this.getSortArrow(l.prop)}{l.label}</div>)}
                    </div> : ""}

                    <div className="stack-list-meta">
                        {this.props.header.meta.map((m,idx) => <div
                            key={idx}
                            className={"stack-list-header-item stack-list-header-link " + (m.classes ? m.classes : "")}
                            title="Click to sort by key"
                            onClick={this.toggleHeader(m.prop)}
                            style={{ width: m.width }}
                        >{this.getSortArrow(m.prop)}{m.label}</div>)}
                    </div>
                </div>
                    {/* Render items through custom configuration */}

                    {
                        this.props.loading? 
                        <>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <Loading 
                                type="bubbles"
                                color="var(--color-primary)"
                                height={100}
                                width={100}
                            />
                        </div>

                        </>
                        :
                        data.length > 0? 
                        data.map((item,idx) => this.props.renderItem(item, idx, this.renderMeta, this.renderLeft))
                        :
                        <div className="sortable-list-empty">{this.props.emptyMessage ? this.props.emptyMessage : "You don't have any items."}</div>
                    }
            </div>
            }
        </>
        );

    }

};